module.exports = __webpack_public_path__ + "static/media/ilustration.e24cd68e.svg";